import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { Card, Row, Col } from "react-bootstrap"
import { CommandBarButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { useTranslation } from "react-i18next";
import RelatedConceptBox from '../../components/Products/sBook/RelatedConceptCreationBox';
import PartyCreationBox from '../../components/Products/sBook/PartyCreationBox';
import SectionCreationBox from '../../components/Products/sBook/SectionCreationBox';
import SectionPartyLinkBox from '../../components/Products/sBook/SectionPartyLinkBox';
import BookUsersBox from '../../components/Products/sBook/BookUsersBox';
import BookBox from '../../components/Products/sBook/BookBox';
import StatusBar from '../../components/Common/StatusBar';
import { __BookRoles, __BookStatus, __MessageTypes, enum__BOOK_SECTION_CLASS, enum__PRIVILEGES } from '../../common/Dictionaries.js';
import {saveBook} from "../../services/sBook/book.service";
import { useGetMessageBookMemberRelationshipProps, useOfGetListPrivilegeBook } from '../../hooks/services/sBook/useOfUser'
import { useHistory } from "react-router-dom";

import '../../styles/css/Card.css';
//import Message from '../../components/Common/Message';
import { Dialog, DialogContent, DialogFooter, DialogType, DirectionalHint, OverflowSet, TooltipHost } from '@fluentui/react';
import { useGetRelatedConceptReference } from '../../hooks/services/sBook/useOfRelatedConcept';
import { __onRenderOverflowButton } from '../../common/CommonFuctions';
import { __OBJECT_STRUCTURE_GetUserProps } from '../../common/ObjectStructures/sBook';
import AuthVerify from '../../components/Templates/Site/AuthVerify';
import MainAppContext from '../../MainAppContext.js';
import { isBookConfigureRol, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../common/Helpers.js';
import Message from '../../components/Common/Message/MessageBox.js' ;

function BookCreation(props) {
    const { t } = useTranslation();
    const history = useHistory();
    const contextSite = useContext(MainAppContext);

    //Objetos helpers requeridos.
    const { token: currentAuth } = useSelector((state) => state.auth);
    const userName = currentAuth !== null ? currentAuth.token.userName.split('\\')[1] : null;
    const bookId = props.match.params.bookId;
    

    //Constantes normales
    const [queryStringBookId, setQueryStringBookId] = useState(!isNullUndefinedOrEmpty(bookId) ? bookId : null);

    const [partyCardIsSelected, setPartyCardIsSelected] = useState(false);
    const [sectionCardIsSelected, setSectionCardIsSelected] = useState(false);


    //Constantes state.
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [closeBookAlertFired, setCloseBookAlertFired] = useState(false);

    const [bookPartyList, setBookPartyList] = useState(null);
    const [bookSectionList, setBookSectionList] = useState(null);
    const [bookSectionPartyList, setBookSectionPartyList] = useState(null);
    
    const [selectedSectionCard, setSelectedSectionCard] = useState(null);
    const [selectedPartyCard, setSelectedPartyCard] = useState(null);
    const [bookUsersCount, setBookUsersCount] = useState(null);
    
    const [relatedConceptHasPartys, setRelatedConceptHasPartys] = useState(false);
    
    const [fireGetBookUsers, setFireGetBookUsers] = useState(false);
    const [buttonActionVisible, setbuttonActionVisible] = useState(true);
    
    const [fireGetSectionStructure, setFireGetSectionStructure] = useState(false);
    

    const [clientRoleList, setClientRoleList] = useState(__BookRoles);
    useOfGetListPrivilegeBook(clientRoleList, setClientRoleList)

    const [auxBookObject, setAuxBookObject] = useState({
        bookCode: "",
        bookNemo: null,
        id: queryStringBookId !== null ? parseInt(queryStringBookId) : null,
        name: "",
        requiresApproval: false,
        statusId: 0
    });

    const [userProps, setUserPropsObject] = useState(__OBJECT_STRUCTURE_GetUserProps()); 
    useGetMessageBookMemberRelationshipProps(queryStringBookId, userName, userProps, setUserPropsObject);

    
    const [relatedConceptIsCleared, setRelatedConceptIsCleared] = useState(false);
    const [bookRelatedConceptItem, setRelatedConceptItem] = useState(null);
    useGetRelatedConceptReference(auxBookObject, bookRelatedConceptItem, setRelatedConceptItem, relatedConceptIsCleared)

    const bookPartyCount = bookPartyList !== null ? (bookPartyList.data.data !== null)? bookPartyList.data.data.length : 0 : 0;
    const bookSectionCount = bookSectionList !== null ? (bookSectionList.data.data !== null)? bookSectionList.data.data.length : 0 : 0;
    const bookPartySectionCount = bookSectionPartyList !== null ? (bookSectionPartyList !== null)? bookSectionPartyList.length : 0 : 0;
    
    const user_has_config_role_action = userProps && userProps.l_privilegeselement && (userProps.l_privilegeselement.find(x => x.l_matrix.find(y => y.actionCode === enum__PRIVILEGES.BOOK_CONFIG) !== undefined) !== undefined)

    let statusFly = 0
    if (auxBookObject.statusId !== 0){
        if ((bookRelatedConceptItem && bookRelatedConceptItem.id !== null) || bookPartyCount > 0) {
            if (bookPartyCount > 0) {
                if (bookSectionCount > 0) {
                    if (bookPartySectionCount > 0) {
                        if (auxBookObject.statusId === 2 || auxBookObject.statusId === 3) {
                            statusFly = 6;
                        }
                        else {
                            statusFly = 5;
                        }
                    }
                    else {
                        statusFly = 4;
                    }
                }
                else {
                    statusFly = 3;
                }
            }
            else {
                statusFly = 2;
            }
        } else {
            statusFly = 1;        
        }
    }
    else {
        statusFly = 0;
    }

   
    

    const selectRelatedConceptId = (item) => {
        if (item !== null && item !== undefined) {
            setRelatedConceptIsCleared(true);
        }
    }
    
    const onFinishBook = () => {
        setbuttonActionVisible(false);
        
        //[##CODELCO-CARD-6-##]
        //En el libro, debe existir una parte administradora obligatoria
        //Debe agregar una validación de secciones de apertura y cierre
        if (auxBookObject.hasMilestone === true) {
            //[##CODELCO-CARD-6-##]
            //En el libro, debe existir una parte administradora obligatoria
            if (bookPartyCount === 0 || isNullUndefined(bookPartyList.data.data.find(x => x.manager === true)) || isNullUndefined(bookPartyList.data.data.find(x => x.counterParty === true))) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-needmanagerandcounterpartys'))
                setbuttonActionVisible(true);
                return;
            }
            //[##CODELCO-CARD-6-##]
            //Debe agregar una validación de secciones de apertura y cierre
            /*if (bookSectionCount === 0 || isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA)) || isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.CIERRE))) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-needsectionclassstructure'))
                setbuttonActionVisible(true);
                return;
            }*/
            if (bookSectionCount === 0) {
                    if (isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA)) && isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.EJECUCION))) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-needsectionclassstructure'))
                        setbuttonActionVisible(true);
                        return;
                    }
                    else {
                        if (
                            (isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA)) && !isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.EJECUCION)))
                            ||
                            (!isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA)) && isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.EJECUCION)))
                        ) {
                            if (isNullUndefined(bookSectionList.data.data.find(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.CIERRE))) {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-needsectionclassstructure'))
                                setbuttonActionVisible(true);
                                return;
                            }
                    }
                }
            }
        }

        auxBookObject.statusId = 2;

        saveBook(auxBookObject).then(() => {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            setbuttonActionVisible(true);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setbuttonActionVisible(true);
        });
    }

    const onPreCloseBook = () => {
        // Admin y sAdmin (securityProps.isAdmin cubre ambos, ver isAdminUser() en backend) pueden
        // cerrar el book manualmente aunque el hito de cierre no esté completo todavía.
        const isAdminOrSAdmin = contextSite.securityProps !== null && contextSite.securityProps.isAdmin === true;

        if (!isAdminOrSAdmin && auxBookObject.hasMilestone === true) {
            if (auxBookObject.hasEndMilestone === false) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-needclosemilestone'))
                setbuttonActionVisible(true);
                return;
            }
        }

        setCloseBookAlertFired(true);
    }
    const onCloseBook = () => {
        auxBookObject.statusId = 3;
        setbuttonActionVisible(false);

        saveBook(auxBookObject).then(() => {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            setbuttonActionVisible(true);
            setCloseBookAlertFired(false);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setbuttonActionVisible(true);
        });
    }
    const onReopenBook = () => {
        auxBookObject.statusId = 2;
        setbuttonActionVisible(false);

        saveBook(auxBookObject).then(() => {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            setbuttonActionVisible(true);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setbuttonActionVisible(true);
        });
    }
    const onOpenBook = () => {
        auxBookObject.statusId = 4;
        setbuttonActionVisible(false);

        saveBook(auxBookObject).then(() => {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            setbuttonActionVisible(true);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setbuttonActionVisible(true);
        });
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        setCloseBookAlertFired(false);
    };

    //Eventos de componente.
    useEffect(()=> {
        const redirectOut = async () => {
            history.push({
                pathname: '/',
            })
        }
        
        //No soy admin y estoy creando libro.
        const hasConfigureBookAccess = false;
        if (contextSite.securityProps !== null && contextSite.securityProps.isAdmin === false && auxBookObject.statusId === 1) {
                redirectOut()
        }
        else if (auxBookObject.statusId === 4 && !isBookConfigureRol(userProps) && (contextSite.securityProps.isAdmin === false && contextSite.securityProps.isSAdmin === false)) {
            redirectOut()
        }

        if (userProps.username !== null && (userProps.hasAccess !== true && userProps.onlyObserver !== true)) {
            redirectOut()
        }

    }, [contextSite.securityProps, userProps, auxBookObject.statusId, history]);

    const onRenderItem = (item) => {
        let styles = null;
        
        switch (item.key) {
            case "finalize":
                styles = {root: {display: (auxBookObject.statusId !== 2 && auxBookObject.statusId !== 3) && statusFly === 5 && buttonActionVisible && bookUsersCount > 0 && contextSite.securityProps !== null && contextSite.securityProps.isAdmin ? "unset" : "none"}}
                break;
            case "close":
                styles = {root: {display: auxBookObject.statusId === 2 && statusFly === 6 && buttonActionVisible && contextSite.securityProps !== null && contextSite.securityProps.isAdmin ? "unset" : "none"}}
                break;
            case "edit":
                styles = {root: {display: auxBookObject.statusId === 2 && statusFly === 6 && buttonActionVisible && contextSite.securityProps !== null && contextSite.securityProps.isAdmin ? "unset" : "none"}}
                break; 
            case "reopen":
                styles = {root: {display: auxBookObject.statusId === 3 && statusFly === 6 && buttonActionVisible && contextSite.securityProps !== null && contextSite.securityProps.isAdmin ? "unset" : "none"}}
                break; 
            default:
                styles = { root: { padding: '10px' } };
                break;
        }

        return (
          <TooltipHost content={item.title} directionalHint={DirectionalHint.rightCenter}>
            <CommandBarButton
              role="menuitem"
              text={item.name}
              aria-label={t('data-lang-msg-onbookfinished')}
              styles={styles}
              iconProps={{ iconName: item.icon }}
              onClick={item.onClick}
            />
          </TooltipHost>
        );
    };


    //Render.
    //##Las siguientes lineas estan agregadas para dar un espaciado bajo el componente concepto relacionado. Esto es para cambios dinamicos de dimensiones de pantalla.
    //##<Row className="pb-2 d-xs-none d-sm-block d-block d-sm-none"></Row>
    //##<Row className="pb-0 d-xs-none d-sm-block d-none d-sm-block"></Row>
    //La cinta de hito de cierre ocupa alto propio dentro del card. .book-info-form-body trae height: 100px fijo (app.css, compartido con BoardCreation),
    //por eso solo cuando la cinta se muestra se libera el alto del card y se reserva el alto original (100px - 2 x 1rem de padding) para el StatusBar.
    const showMilestoneClosedMessage = !!auxBookObject && auxBookObject.hasMilestone === true && auxBookObject.hasEndMilestone === true;

    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            <Row className="pb-2">
                <Col>
                    <Card className='book-info-form'>
                        <Card.Body className="book-info-form-body" style={showMilestoneClosedMessage ? { height: 'auto' } : undefined}>
                            <Row>
                                {
                                    //La cinta va en el flujo normal (sin position absolute) para no taparse con el StatusBar ni la botonera.
                                    showMilestoneClosedMessage &&
                                    <div className="col-12 pb-2">
                                        <Message
                                            inputParam_Message={ t('data-lang-msg-bookismilestoneclosed') }
                                            inputParam_Display={ true }
                                            inputParam_MessageType={ __MessageTypes.WARNING }
                                            inputParam_SetterMessage={ undefined }
                                        />
                                    </div>
                                }
                                <div className="col-9 col-sm-10 col-xl-11" style={showMilestoneClosedMessage ? { minHeight: '68px' } : undefined}>
                                    <StatusBar statusId={statusFly}  statusList={__BookStatus} statusKeyField="key" statusValueField="value" />
                                </div>
                                    {
                                        //[##CODELCO-CARD-6-##]
                                        //El hito de cierre marca estado de Libro a cerrado siempre
                                        //Admin/sAdmin (securityProps.isAdmin cubre ambos) igual pueden operar el book
                                        //manualmente aunque el hito de cierre ya se haya completado.
                                        (auxBookObject && ((auxBookObject.hasMilestone === null || auxBookObject.hasMilestone === false) || (auxBookObject.hasMilestone === true && auxBookObject.hasEndMilestone === false) || auxBookObject.hasMilestoneProblem === true || (contextSite.securityProps !== null && contextSite.securityProps.isAdmin === true))) &&
                                        <div className="col-3 col-sm-2 col-xl-1 pt-sm-3">
                                            <OverflowSet
                                                className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                role="menubar"
                                                items={(user_has_config_role_action || (contextSite.securityProps !== null && contextSite.securityProps.isAdmin)) ? [
                                                    {
                                                        key: 'finalize',
                                                        icon: 'ReceiptCheck',
                                                        name: t('data-lang-btn-finalize'),
                                                        title: t('data-lang-msg-onbookfinished'),
                                                        onClick: () => onFinishBook(),
                                                    },
                                                    {
                                                        key: 'edit',
                                                        icon: 'ProcessMetaTask',
                                                        name: t('data-lang-btn-edit'),
                                                        title: t('data-lang-msg-onbookopen'),
                                                        onClick: () => onOpenBook(),
                                                    },
                                                    {
                                                        key: 'close',
                                                        icon: 'DictionaryRemove',
                                                        name: t('data-lang-btn-close'),
                                                        title: t('data-lang-msg-onbookclosed'),
                                                        onClick: () => onPreCloseBook(),
                                                    },
                                                    {
                                                        key: 'reopen',
                                                        icon: 'FolderOpen',
                                                        name: t('data-lang-btn-open'),
                                                        title: t('data-lang-msg-onbookreopen'),
                                                        onClick: () => onReopenBook(),
                                                    }
                                                ] : []}
                                                onRenderOverflowButton={__onRenderOverflowButton}
                                                onRenderItem={onRenderItem}
                                            />
                                        </div>
                                    }
                            </Row>
                            <Row>
                                <div style={{position: "absolute", width: "260px", right: "16px", marginTop: "-6px"}} className='pt-2'>
                                    <Message
                                        inputParam_Position='absolute'
                                        inputParam_Message={ messageConfig.message }
                                        inputParam_Display={ messageConfig.showMessage }
                                        inputParam_MessageType={ messageConfig.messageType }
                                        inputParam_SetterMessage={ setMessageConfig }
                                    />
                                </div>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="pb-2">
                <Col lg={12} xl={5} className="pe-2">
                    <Row className="pb-2">
                        <Col className="book-info">
                            <BookBox
                                relatedConceptItem={bookRelatedConceptItem}
                                queryStringBookId={queryStringBookId}
                                setterQueryStringBookId={setQueryStringBookId}
                                setterBookObject={setAuxBookObject}
                                editMode={auxBookObject.statusId !== 2 && auxBookObject.statusId !== 3}
                                userHasConfigRoleAction={user_has_config_role_action}
                                showNumber={true}
                                showSwitchLayout={false}
                                statusFly={ statusFly }
                                isCreatrionMode={true}
                                userProps={userProps}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="book-related-concept">
                            <RelatedConceptBox
                                setRelatedConceptHasPartys={setRelatedConceptHasPartys}
                                bookObject={auxBookObject} statusFly={ statusFly }
                                setterAuxBookObject={setAuxBookObject}
                                setterBookRelatedConcept={selectRelatedConceptId}
                                editMode={auxBookObject.statusId !== 2 && auxBookObject.statusId !== 3}
                                userHasConfigRoleAction={user_has_config_role_action}
                                isCreatrionMode={true}
                                setFireGetSectionStructure={setFireGetSectionStructure}
                            />
                        </Col>
                    </Row>
                    <Row className="pb-2 d-xs-none d-sm-block d-block d-sm-none">
                    </Row>
                    <Row className="pb-0 d-xs-none d-sm-block d-none d-sm-block">
                    </Row>
                </Col>
                <Col className="ps-0 pe-4">
                {
                    !isNullUndefined(clientRoleList) &&
                    <PartyCreationBox
                        bookObject={ auxBookObject }
                        statusFly={ statusFly }
                        setterSelectedCard={ setSelectedPartyCard }
                        setterBookPartyList={ setBookPartyList }
                        roleList={ clientRoleList }
                        editMode={auxBookObject.statusId !== 2 && auxBookObject.statusId !== 3}
                        setPartyCardIsSelected={setPartyCardIsSelected}
                        relatedConceptHasPartys={relatedConceptHasPartys}
                        userHasConfigRoleAction={user_has_config_role_action}
                        isCreatrionMode={true}
                    />
                }
                </Col>
            </Row>
            <Row className='pe-2'>
                <Col className="pb-2 pe-1" lg={12} xl={5}>
                {
                    !isNullUndefined(clientRoleList) &&
                    <BookUsersBox
                        bookObject={ auxBookObject }
                        bookPartyList={ bookPartyList }
                        roleList={ clientRoleList }
                        selectedPartyCard={ selectedPartyCard }
                        editMode={auxBookObject.statusId !== 2 && auxBookObject.statusId !== 3}
                        fireGetBookUsers={ fireGetBookUsers }
                        setterFireGetBookUsers={setFireGetBookUsers}
                        setterBookUsersCount={setBookUsersCount}
                        partyCardIsSelected={partyCardIsSelected}
                        setPartyCardIsSelected={setPartyCardIsSelected}
                        userHasConfigRoleAction={user_has_config_role_action}
                        isCreatrionMode={true}
                    />
                }
                </Col>
                <Col className='ps-1' lg={12} xl={7}>
                    <Row className="pb-2">
                        <Col className="book-section parent">
                        {
                            auxBookObject &&
                            <SectionCreationBox
                                bookObject={ auxBookObject }
                                setBookObject={ setAuxBookObject }
                                setterSelectedCard={ setSelectedSectionCard }
                                setterBookSectionList={ setBookSectionList }
                                bookPartyCount={ bookPartyCount }
                                bookPartyList={bookPartyList}
                                editMode={auxBookObject.statusId !== 2 && auxBookObject.statusId !== 3}
                                setSectionCardIsSelected={setSectionCardIsSelected}
                                userHasConfigRoleAction={user_has_config_role_action}
                                isCreatrionMode={true}
                                statusFly={ statusFly }
                                fireGetSectionStructure={fireGetSectionStructure}
                                setFireGetSectionStructure={setFireGetSectionStructure}
                            />
                        }
                        </Col>
                    </Row>
                    <Row className="pb-2">
                        <Col className="book-user-section">
                            <SectionPartyLinkBox
                                bookObject={ auxBookObject }
                                bookSectionCount={ bookSectionCount }
                                bookPartyCount={ bookPartyCount }
                                setterBookSectionPartyList={ setBookSectionPartyList }
                                selectedSectionCard={ selectedSectionCard }
                                editMode={auxBookObject.statusId !== 2 && auxBookObject.statusId !== 3}
                                setterFireGetBookUsers={setFireGetBookUsers}
                                sectionCardIsSelected={sectionCardIsSelected}
                                setSectionCardIsSelected={setSectionCardIsSelected}
                                statusFly={ statusFly }
                                bookSectionList={ bookSectionList }
                                userHasConfigRoleAction={user_has_config_role_action}
                                isCreatrionMode={true}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {
                closeBookAlertFired && 
                <Dialog
                    hidden={!closeBookAlertFired}
                    onDismiss={onHideDialog}
                    minWidth={800}
                    maxWidth={800}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-boxname-warning'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 800 } },
                    }}
                    >
                    <DialogContent>
                        { t('data-lang-msg-closebookalert') }
                    </DialogContent>
                    <DialogFooter>
                        <Row>
                            <Col className='col-auto ms-auto'>
                                <PrimaryButton onClick={onCloseBook} className='mx-1' text={t('data-lang-btn-accept')} />
                                <DefaultButton onClick={onHideDialog} className='mx-1' text={t('data-lang-btn-close')} />
                            </Col>
                        </Row>
                    </DialogFooter>
                </Dialog>
            }
        </>
    ); 
}

export default BookCreation;